import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Page = styled.div`
  min-height: calc(100vh - 140px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eef2ff 0%, #f5f3ff 100%);
  padding: 2rem 1rem;
`;

const Card = styled.div`
  width: 100%;
  max-width: 460px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(99, 102, 241, 0.15);
  padding: 28px;
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
`;

const Logo = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  font-weight: 800;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 1.4rem;
  font-weight: 800;
  color: #1f2937;
`;

const Subtitle = styled.p`
  color: #6b7280;
  margin: 0 0 1.25rem 0;
`;

const Form = styled.form`
  display: grid;
  gap: 14px;
`;

const Label = styled.label`
  font-size: 0.9rem;
  color: #374151;
  font-weight: 600;
`;

const InputWrap = styled.div`
  position: relative;
`;

const Input = styled.input`
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 1rem;
  transition: box-shadow 0.2s, border-color 0.2s;
  &:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.15);
  }
`;

const Toggle = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #6b7280;
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
`;

const Button = styled.button`
  width: 100%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  border: none;
  padding: 12px 14px;
  border-radius: 10px;
  font-weight: 800;
  letter-spacing: 0.2px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.2s ease;
  box-shadow: 0 10px 24px rgba(99, 102, 241, 0.25);
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 14px 30px rgba(99, 102, 241, 0.3);
  }
`;

const Muted = styled.a`
  color: #6b7280;
  font-size: 0.88rem;
  text-decoration: none;
  &:hover {
    color: #4f46e5;
  }
`;

const AdminLogin = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  return (
    <Page>
      <Card>
        <Brand>
          <Logo>İ</Logo>
          <Title>İşHazır Admin</Title>
        </Brand>
        <Subtitle>
          Admin paneline erişmek için, admin olarak tanımlanan e-posta adresinizle
          önce normal giriş yapmanız gerekir. Ardından doğrudan <strong>/admin</strong>{' '}
          sayfasına gidebilirsiniz.
        </Subtitle>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            navigate('/login');
          }}
        >
          <div>
            <Label>Kullanıcı Adı</Label>
            <Input
              value=""
              placeholder="Admin e-posta için giriş sayfasına yönlendirileceksiniz"
              disabled
            />
          </div>

          <div>
            <Label>Şifre</Label>
            <InputWrap>
              <Input
                type={show ? 'text' : 'password'}
                value=""
                disabled
                placeholder="Şifre girişi normal giriş sayfasından yapılır"
              />
              <Toggle
                type="button"
                onClick={() => setShow((prev) => !prev)}
              >
                {show ? 'Gizle' : 'Göster'}
              </Toggle>
            </InputWrap>
          </div>

          <Row>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input id="remember" type="checkbox" defaultChecked readOnly />
              <label
                htmlFor="remember"
                style={{ color: '#6b7280', fontSize: 14 }}
              >
                Beni hatırla
              </label>
            </div>
            <Muted
              href="#"
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              Şifremi unuttum
            </Muted>
          </Row>

          <Button type="submit">Giriş sayfasına git</Button>
        </Form>
      </Card>
    </Page>
  );
};

export default AdminLogin;

